$w.onReady(function () {
$w("#shoppingCartIcon4").show();
});